// src/components/ModalVerOrdenCobroRemitos.jsx
import { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import moment from "moment";
import { getOrdenCobroRemitoById } from "../helpers/rutaOrdenCobroRemitos";

const $ = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// 🔹 mismo criterio que en ModalVerOrdenPagoRemitos
const origenCobro = (p) => {
  const medio = String(p?.medio || "").toLowerCase();

  if (medio === "efectivo") {
    const desc = p?.caja?.descripcion;
    return desc ? `Caja: ${desc}` : p?.caja ? `Caja: ${p.caja}` : "-";
  }

  if (medio === "transferencia") {
    const c = p?.cuentaBancaria;
    const etiqueta = c?.alias || c?.numero || "";
    return etiqueta
      ? `Cuenta: ${etiqueta}`
      : p?.cuentaBancaria
      ? `Cuenta: ${p.cuentaBancaria}`
      : "-";
  }

  if (medio === "cheque") {
    const nro = p?.referencia || p?.nroCheque || "";
    const fv = p?.fechaCheque
      ? ` — ${moment(p.fechaCheque).format("DD/MM/YYYY")}`
      : "";
    return nro ? `Cheque ${nro}${fv}` : "Cheque";
  }

  if (medio === "icheq") {
    return p?.referencia ? `iCheq ${p.referencia}` : "iCheq";
  }

  return "-";
};

export default function ModalVerOrdenCobroRemitos({ show, ocId, onHide }) {
  const [oc, setOc] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !ocId) return;
    (async () => {
      setLoading(true);
      try {
        const r = await getOrdenCobroRemitoById(ocId);
        if (r?.ok) setOc(r.orden);
        else alert(r?.msg || "No se pudo cargar la Orden de Cobro.");
      } catch (e) {
        console.error(e);
        alert("Error cargando la Orden de Cobro.");
      } finally {
        setLoading(false);
      }
    })();
  }, [show, ocId]);

  // 👇 usamos siempre este arreglo para cobros
  const cobros = oc?.cobros || oc?.pagos || [];
  const retenciones = oc?.retenciones || [];
  const netoFallback =
    cobros.reduce((s, m) => s + Number(m.importe || 0), 0) -
    retenciones.reduce((s, m) => s + Number(m.importe || 0), 0);

  const netoMostrado =
    oc?.totales?.netoCobrado != null ? oc.totales.netoCobrado : netoFallback;

  return (
    <Modal show={show} onHide={() => onHide(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {oc ? `Orden de Cobro ${oc.numero}` : "Orden de Cobro"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading && <div>Cargando…</div>}
        {oc && !loading && (
          <>
            <div className="mb-2">
              <b>Fecha:</b>{" "}
              {oc.fecha ? moment(oc.fecha).format("DD/MM/YYYY") : "-"}
              <br />
              <b>Cliente:</b>{" "}
              {oc?.cliente?.razonsocial || oc?.cliente?.nombre || "-"}
              <br />
              {oc?.proveedor && (
                <>
                  <b>Proveedor (filtro):</b>{" "}
                  {oc.proveedor.razonsocial || oc.proveedor.nombre}
                  <br />
                </>
              )}
              <b>Estado:</b> {(oc.estado || "").toUpperCase()}
            </div>

            <h6>Remitos aplicados</h6>
            <Table size="sm" bordered hover>
              <thead>
                <tr>
                  <th>Remito</th>
                  <th>Fecha</th>
                  <th style={{ textAlign: "right" }}>Pactado</th>
                  <th style={{ textAlign: "right" }}>Cobrado Ant.</th>
                  <th style={{ textAlign: "right" }}>Aplicado</th>
                </tr>
              </thead>
              <tbody>
                {(oc.aplicaciones || []).map((a, i) => {
                  const r = a.remito || {};
                  return (
                    <tr key={i}>
                      <td>#{String(r.codrem || "").padStart(6, "0")}</td>
                      <td>
                        {r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>${$(a.pactado)}</td>
                      <td style={{ textAlign: "right" }}>
                        ${$(a.pagadoAnterior)}
                      </td>
                      <td style={{ textAlign: "right" }}>${$(a.aplicado)}</td>
                    </tr>
                  );
                })}
                {!(oc.aplicaciones || []).length && (
                  <tr>
                    <td colSpan={5} className="text-muted text-center">
                      Sin aplicaciones
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <h6 className="mt-3">Cobros</h6>
            <Table size="sm" bordered hover>
              <thead>
                <tr>
                  <th>Medio</th>
                  <th>Origen / Ref.</th>
                  <th style={{ textAlign: "right" }}>Importe</th>
                </tr>
              </thead>
              <tbody>
                {cobros.map((p, i) => (
                  <tr key={i}>
                    <td>{(p.medio || "").toUpperCase()}</td>
                    <td>{origenCobro(p)}</td>
                    <td style={{ textAlign: "right" }}>${$(p.importe)}</td>
                  </tr>
                ))}
                {!cobros.length && (
                  <tr>
                    <td colSpan={3} className="text-muted text-center">
                      Sin cobros
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {retenciones.length > 0 && (
              <>
                <h6 className="mt-3">Deducciones</h6>
                <Table size="sm" bordered hover>
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Comprobante</th>
                      <th style={{ textAlign: "right" }}>Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {retenciones.map((r, i) => (
                      <tr key={i}>
                        <td>{r.tipo}</td>
                        <td>{r.comprobante || ""}</td>
                        <td style={{ textAlign: "right" }}>
                          ${$(r.importe)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            <div className="mt-3">
              <b>Totales —</b>{" "}
              Aplicado: ${$(oc?.totales?.aplicado || 0)} — Deducciones: $
              {$(oc?.totales?.retenciones || 0)} — Neto Cobrado: $
              {$(netoMostrado)}
            </div>
            {oc.observaciones && (
              <div className="mt-2">
                <b>Obs:</b> {oc.observaciones}
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
